import { useIsRestoring } from '@tanstack/react-query'
import { useMemo } from 'react'
import { useCollectionQuantities } from '@/hooks/collections/useCollectionCrud'
import { useUserQuantities } from '@/hooks/collections/useUserQuantities'
import { useUserFilters } from '@/hooks/filters/useUserFilters'
import { useFilterStore } from '@/store/filterStore'
import type { CardFilters } from '@/types'
import { filterCards, sortCards, deriveCardFilterOptions } from '@/utils/cardFiltering'
import { useCards } from './useCards'

export function useFilteredCards(filters: CardFilters) {
  const isRestoring = useIsRestoring()
  useUserQuantities()
  const { data: allCards, isLoading, isFetching } = useCards()
  const { data: quantities } = useCollectionQuantities()
  const { data: userFilters } = useUserFilters()
  const showHidden = useFilterStore((s) => s.showHidden)

  const filterOptions = useMemo(() => (allCards ? deriveCardFilterOptions(allCards) : undefined), [allCards])

  const cards = useMemo(() => {
    if (!allCards) return []
    const filtered = filterCards(allCards, filters, quantities, userFilters, showHidden)
    return sortCards(filtered, filters.sort, filters.order)
  }, [allCards, filters, quantities, userFilters, showHidden])

  return {
    cards,
    filterOptions,
    totalCount: cards.length,
    isLoading: isLoading || isRestoring,
    isFetching,
  }
}
